import { defineStore } from 'pinia'

const useUserStore = defineStore('user', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useUserStore
